import SockJS from "sockjs-client";
import {config} from "@/config";
import Stomp from "webstomp-client";
import {auth} from "@/plugins/auth";

const state = {
    stompClient: null,
    socket: null,
    connectionError: false
}

const getters = {
    connectionError: state => state.connectionError
}

const actions = {

    async connect({commit, dispatch}, pins){
        dispatch('closeSocket')
        if(auth.isLoggedIn()){
            await auth.renewToken()
        }
        state.socket = new SockJS(`${config.serverUrl}socket?access_token=${auth.getToken()}`)
        state.stompClient = Stomp.over(state.socket)
        state.stompClient.connect(
            {},
            () => {
                commit('setConnectionError', false)

                pins.forEach(pin => {
                    state.stompClient.subscribe(`/gamification/activity/${pin}`, (message) => {
                        const update = JSON.parse(message.body)
                        if(update.recordType === 'ATT'){
                            dispatch('SeminarAttendance/fetchBySeminarId', update.lessonId, {root: true})
                        } else if(update.recordType === 'EVAL'){
                            dispatch('SeminarEvaluation/fetchBySeminarId', update.lessonId, {root: true})
                        }
                    })
                })
            },
            (error) => {
                console.error('Seminar socket connection error:', error)
                commit('setConnectionError', true)
            }
        )
    },

    closeSocket(){
        if(state.stompClient){
            try {
                state.stompClient.disconnect()
            } catch (e) {
                // socket may still be CONNECTING
            }
        }
        state.stompClient = null
        state.socket = null
    },

    disconnect({dispatch}){
        dispatch('closeSocket')
        state.connectionError = false
    }
}

const mutations = {
    setConnectionError: (state, error) => (state.connectionError = error)
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
